<template>
	<transition 
			appear
			:appear-active-class="$_trvLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow fluid" no-gutters>
			<v-col>
				<v-row>
					<v-col>
						<template v-if="contentVals_.title">
							<v-sheet
									class="customVSheet"
									:color="$_trvLyt_styleHeaderSheetColor"
									:dark="$_trvLyt_styleHeaderSheetDark"
									:elevation="$_trvLyt_styleHeaderSheetElevation"
									:light="$_trvLyt_styleHeaderSheetLight">
								<v-card color="transparent" flat>
									<v-card-text>
										<v-row class="row_" dense>
											<v-col cols="auto" class="center">
												<v-bottom-sheet v-model="list_">
													<template v-slot:activator="{ on }">
														<v-btn	class="customVBtn"

																icon
														
																:color="$_trvLyt_styleSelectButtonColor"
																:dark="$_trvLyt_styleSelectButtonDark"
																:large="$_trvLyt_styleSelectButtonLarge"
																:light="$_trvLyt_styleSelectButtonLight"
																:outlined="$_trvLyt_styleSelectButtonOutlined"
																:small="$_trvLyt_styleSelectButtonSmall"

																v-on="on">
															<v-icon v-text="contentVals_.icon" />
														</v-btn>
													</template>
													<v-list>
														<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
															<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
																<v-list-item
																		:key="contentKey"
																		@click="$_trvLyt_selectListItem(contentVals, contentKey)">
																	<v-list-item-avatar>
																		<v-icon v-text="contentVals.icon" />
																	</v-list-item-avatar>
																	<v-list-item-title v-text="contentVals.title" />
																</v-list-item>
															</template>
														</template>
													</v-list>
												</v-bottom-sheet>
											</v-col>
											<v-col cols="auto" class="center">
												<center>
													<span	class="headline"
															v-html="$_trvLyt_langContentTitle(contentVals_)" />
												</center>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-sheet>
						</template>
					</v-col>
				</v-row>
				<v-row>
					<template v-if="$_trvLyt_showColLeftTop() || $_trvLyt_showColLeftBottom()">
						<v-col cols="12" md="3">
							<template v-if="$_trvLyt_showColLeftTop()">
								<v-row no-gutters>
									<v-col>
										<v-sheet
												class="customVSheet"
												:color="$_trvLyt_styleBodySheetColor"
												:dark="$_trvLyt_styleBodySheetDark"
												:elevation="$_trvLyt_styleBodySheetElevation"
												:light="$_trvLyt_styleBodySheetLight">
											<v-card	class="customVCard"
													color="transparent"
													flat>
												<template v-if="isObject(contentVals_.image)">
													<v-row>
														<v-col>
															<v-img	class="customVImg"
																	:src="$_trvLyt_styleContentImageUrl(contentVals_)" />
														</v-col>
													</v-row>
												</template>
												<v-row>
													<v-col>
														<template v-if="contentVals_.subTitle">
															<v-card-title>
																<span v-html="$_trvLyt_langContentSubTitle(contentVals_)" />
															</v-card-title>
														</template>
														<template v-if="!isFalse($_trvLyt_langContentText(contentVals))">
															<v-card-text>
																<span	class="markdown"
																		v-html="marked($_trvLyt_langContentText(contentVals_))" />
															</v-card-text>
														</template>
														<template v-if="contentVals_.actionButtons">
															<v-card-actions>
																<v-row dense>
																	<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals_.actionButtons, 'order')">
																		<v-col :key="actionButtonKey" cols="12">
																			<v-btn	class="customVBtn"
																					:block="$_trvLyt_styleActionButtonBlock"
																					:color="$_trvLyt_styleActionButtonColor"
																					:dark="$_trvLyt_styleActionButtonDark"
																					:depressed="$_trvLyt_styleActionButtonDepressed"
																					:elevation="$_trvLyt_styleActionButtonElevation"
																					:large="$_trvLyt_styleActionButtonLarge"
																					:light="$_trvLyt_styleActionButtonLight"
																					:outlined="$_trvLyt_styleActionButtonOutlined"
																					:rounded="$_trvLyt_styleActionButtonRounded"
																					:small="$_trvLyt_styleActionButtonSmall"
																					:text="$_trvLyt_styleActionButtonFlat"
																					@click="openLink(actionButtonVals.link)"
																					v-text="$_trvLyt_langActionButtonTitle(actionButtonVals)" />
																		</v-col>
																	</template>
																</v-row>
															</v-card-actions>
														</template>
													</v-col>
												</v-row>
											</v-card>
										</v-sheet>
									</v-col>
								</v-row>
							</template>
							<template v-if="$_trvLyt_showColLeftBottom() && !$_trvLyt_stateAppIsMobileScreen">
								<template v-if="$_trvLyt_activeItemButtons()">
									<v-row class="mt-4" no-gutters>
										<v-col>
											<v-sheet
													class="customVSheet"
													:color="$_trvLyt_styleBodySheetColor"
													:dark="$_trvLyt_styleBodySheetDark"
													:elevation="$_trvLyt_styleBodySheetElevation"
													:light="$_trvLyt_styleBodySheetLight">
												<v-card	class="customVCard"
														color="transparent"
														flat>
													<v-row>
														<v-col>
															<v-card-actions>
																<v-row dense>
																	<template v-for="(actionButtonVals, actionButtonKey) in sortObject($_trvLyt_activeItemButtons(), 'order')">
																		<v-col :key="actionButtonKey" cols="12">
																			<v-btn	class="customVBtn"
																					:block="$_trvLyt_styleActionButtonBlock"
																					:color="$_trvLyt_styleActionButtonColor"
																					:dark="$_trvLyt_styleActionButtonDark"
																					:depressed="$_trvLyt_styleActionButtonDepressed"
																					:elevation="$_trvLyt_styleActionButtonElevation"
																					:large="$_trvLyt_styleActionButtonLarge"
																					:light="$_trvLyt_styleActionButtonLight"
																					:outlined="$_trvLyt_styleActionButtonOutlined"
																					:rounded="$_trvLyt_styleActionButtonRounded"
																					:small="$_trvLyt_styleActionButtonSmall"
																					:text="$_trvLyt_styleActionButtonFlat"
																					@click="openLink(actionButtonVals.link)"
																					v-text="$_trvLyt_langActionButtonTitle(actionButtonVals)" />
																		</v-col>
																	</template>
																</v-row>
															</v-card-actions>
														</v-col>
													</v-row>
												</v-card>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
							</template>
						</v-col>
					</template>
					<v-col>
						<template v-if="!isEmpty(contentVals_.items)">
							<v-sheet
									class="customVSheet sheet_ pa-3"
									:color="$_trvLyt_styleTreeviewSheetColor"
									:dark="$_trvLyt_styleTreeviewSheetDark"
									:elevation="$_trvLyt_styleTreeviewSheetElevation"
									:light="$_trvLyt_styleTreeviewSheetLight">
								<v-treeview	
										:active.sync="active_[contentKey_]"
										v-model="selected_[contentKey_]" return-object

										:activatable="$_trvLyt_styleTreeviewActivatable"
										:color="$_trvLyt_styleTreeviewColor"
										:dark="$_trvLyt_styleTreeviewDark"
										:dense="$_trvLyt_styleTreeviewDense"
										:expand-icon="$_trvLyt_styleTreeviewExpandIcon"
										:hoverable="$_trvLyt_styleTreeviewHoverable"
										:light="$_trvLyt_styleTreeviewLight"
										:multiple-active="$_trvLyt_styleTreeviewMultipleActive"
										:off-icon="$_trvLyt_styleTreeviewOffIcon"
										:on-icon="$_trvLyt_styleTreeviewOnIcon"
										:open-all="$_trvLyt_styleTreeviewOpenAll"
										:open-on-click="$_trvLyt_styleTreeviewOpenOnClick"
										:rounded="$_trvLyt_styleTreeviewRounded"
										:selectable="$_trvLyt_styleTreeviewSelectable"
										:selected-color="$_trvLyt_styleTreeviewSelectedColor"
										:selection-type="$_trvLyt_styleTreeviewSelectionType"
										:shaped="$_trvLyt_styleTreeviewShaped"
										:transition="$_trvLyt_styleTreeviewTrainsition"

										:items="contentVals_.items" />
							</v-sheet>
						</template>
					</v-col>
				</v-row>
				<template v-if="$_trvLyt_showColLeftBottom() && $_trvLyt_stateAppIsMobileScreen">
					<template v-if="$_trvLyt_activeItemButtons()">
						<v-row>
							<v-col>
								<v-sheet
										class="customVSheet"
										:color="$_trvLyt_styleBodySheetColor"
										:dark="$_trvLyt_styleBodySheetDark"
										:elevation="$_trvLyt_styleBodySheetElevation"
										:light="$_trvLyt_styleBodySheetLight">
									<v-card	class="customVCard"
											color="transparent"
											flat>
										<v-row>
											<v-col>
												<v-card-actions>
													<v-row dense>
														<template v-for="(actionButtonVals, actionButtonKey) in sortObject($_trvLyt_activeItemButtons(), 'order')">
															<v-col :key="actionButtonKey" cols="12">
																<v-btn	class="customVBtn"
																		:block="$_trvLyt_styleActionButtonBlock"
																		:color="$_trvLyt_styleActionButtonColor"
																		:dark="$_trvLyt_styleActionButtonDark"
																		:depressed="$_trvLyt_styleActionButtonDepressed"
																		:elevation="$_trvLyt_styleActionButtonElevation"
																		:large="$_trvLyt_styleActionButtonLarge"
																		:light="$_trvLyt_styleActionButtonLight"
																		:outlined="$_trvLyt_styleActionButtonOutlined"
																		:rounded="$_trvLyt_styleActionButtonRounded"
																		:small="$_trvLyt_styleActionButtonSmall"
																		:text="$_trvLyt_styleActionButtonFlat"
																		@click="openLink(actionButtonVals.link)"
																		v-text="$_trvLyt_langActionButtonTitle(actionButtonVals)" />
															</v-col>
														</template>
													</v-row>
												</v-card-actions>
											</v-col>
										</v-row>
									</v-card>
								</v-sheet>
							</v-col>
						</v-row>
					</template>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'TreeviewLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				list_: false,

				contentKey_: null,
				contentVals_: {},

				active_: {},
				selected_: {},
				buttons_: {},
			}
		},
		computed: {
			// state
			$_trvLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang
			// (contents)
			$_trvLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_trvLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_trvLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (contents - action buttons)
			$_trvLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_trvLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_trvLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_trvLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_trvLyt_styleSelectButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'selectButton')
			},
			$_trvLyt_styleSelectButtonColor() {
				const self_ = this;
				const button_ =self_.$_trvLyt_styleSelectButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_trvLyt_styleSelectButtonDark() {
				const self_ = this;
				const button_ = self_.$_trvLyt_styleSelectButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_trvLyt_styleSelectButtonLarge() {
				const self_ = this;
				const button_ = self_.$_trvLyt_styleSelectButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_trvLyt_styleSelectButtonLight() {
				const self_ = this;
				const button_ = self_.$_trvLyt_styleSelectButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_trvLyt_styleSelectButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_trvLyt_styleSelectButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_trvLyt_styleSelectButtonSmall() {
				const self_ = this;
				const button_ = self_.$_trvLyt_styleSelectButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_trvLyt_styleHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'headerSheet')
			},
			$_trvLyt_styleHeaderSheetColor() {
				const self_ = this;
				const headerSheet_ = self_.$_trvLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.color)
			},
			$_trvLyt_styleHeaderSheetDark() {
				const self_ = this;
				const headerSheet_ = self_.$_trvLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_trvLyt_styleHeaderSheetElevation() {
				const self_ = this;
				const headerSheet_ = self_.$_trvLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.elevation)
			},
			$_trvLyt_styleHeaderSheetLight() {
				const self_ = this;
				const headerSheet_ = self_.$_trvLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.light)
			},
			$_trvLyt_styleBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'bodySheet')
			},
			$_trvLyt_styleBodySheetColor() {
				const self_ = this;
				const bodySheet_ = self_.$_trvLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.color)
			},
			$_trvLyt_styleBodySheetDark() {
				const self_ = this;
				const bodySheet_ = self_.$_trvLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.dark)
			},
			$_trvLyt_styleBodySheetElevation() {
				const self_ = this;
				const bodySheet_ = self_.$_trvLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.elevation)
			},
			$_trvLyt_styleBodySheetLight() {
				const self_ = this;
				const bodySheet_ = self_.$_trvLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.light)
			},
			$_trvLyt_styleTreeviewSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'treeviewSheet')
			},
			$_trvLyt_styleTreeviewSheetColor() {
				const self_ = this;
				const treeviewSheet_ = self_.$_trvLyt_styleTreeviewSheet;
				if(self_.isFalse(treeviewSheet_)) { return null }
				return self_.getStylesVal(treeviewSheet_.color)
			},
			$_trvLyt_styleTreeviewSheetDark() {
				const self_ = this;
				const treeviewSheet_ = self_.$_trvLyt_styleTreeviewSheet;
				if(self_.isFalse(treeviewSheet_)) { return null }
				return self_.getStylesVal(treeviewSheet_.dark)
			},
			$_trvLyt_styleTreeviewSheetElevation() {
				const self_ = this;
				const treeviewSheet_ = self_.$_trvLyt_styleTreeviewSheet;
				if(self_.isFalse(treeviewSheet_)) { return null }
				return self_.getStylesVal(treeviewSheet_.elevation)
			},
			$_trvLyt_styleTreeviewSheetLight() {
				const self_ = this;
				const treeviewSheet_ = self_.$_trvLyt_styleTreeviewSheet;
				if(self_.isFalse(treeviewSheet_)) { return null }
				return self_.getStylesVal(treeviewSheet_.light)
			},
			$_trvLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_trvLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_trvLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_trvLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_trvLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_trvLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_trvLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_trvLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_trvLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_trvLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_trvLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_trvLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_trvLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_trvLyt_styleTreeview() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'treeview')
			},
			$_trvLyt_styleTreeviewActivatable() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.activatable)
			},
			$_trvLyt_styleTreeviewColor() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.color)
			},
			$_trvLyt_styleTreeviewDark() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.dark)
			},
			$_trvLyt_styleTreeviewDense() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.dense)
			},
			$_trvLyt_styleTreeviewExpandIcon() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.expandIcon)
			},
			$_trvLyt_styleTreeviewHoverable() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.hoverable)
			},
			$_trvLyt_styleTreeviewLight() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.light)
			},
			$_trvLyt_styleTreeviewMultipleActive() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.multipleActive)
			},
			$_trvLyt_styleTreeviewOffIcon() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.offIcon)
			},
			$_trvLyt_styleTreeviewOnIcon() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.onIcon)
			},
			$_trvLyt_styleTreeviewOpenAll() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.openAll)
			},
			$_trvLyt_styleTreeviewOpenOnClick() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.openOnClick)
			},
			$_trvLyt_styleTreeviewRounded() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.rounded)
			},
			$_trvLyt_styleTreeviewSelectable() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.selectable)
			},
			$_trvLyt_styleTreeviewSelectedColor() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.selectedColor)
			},
			$_trvLyt_styleTreeviewSelectionType() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.selectionType)
			},
			$_trvLyt_styleTreeviewShaped() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.shaped)
			},
			$_trvLyt_styleTreeviewTrainsition() {
				const self_ = this;
				const treeview_ = self_.$_trvLyt_styleTreeview;
				if(self_.isFalse(treeview_)) { return null }
				return self_.getStylesVal(treeview_.transition)
			},
			// (contents)
			$_trvLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_trvLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_trvLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_trvLyt_firstOfList()
		},
		methods: {
			$_trvLyt_firstOfList() {
				const self_ = this;
				
				const keys_ = Object.keys(self_.contents)
				const first_ = keys_[0]

				self_.$_trvLyt_selectListItem(self_.contents[first_], first_)
			},
			$_trvLyt_selectListItem(contentVals, contentKey) {
				const self_ = this;
				
				self_.contentKey_ = contentKey;
				self_.contentVals_ = contentVals;

				self_.list_ = false;
			},
			$_trvLyt_showColLeftTop() {
				const self_ = this;
				
				const show_ = 	self_.contentVals_.subTitle || 
								self_.contentVals_.text || 
								!self_.isEmpty(self_.contentVals_.image) || 
								!self_.isEmpty(self_.contentVals_.actionButtons)

				return show_
			},
			$_trvLyt_showColLeftBottom() {
				const self_ = this;

				const key_ = self_.contentKey_;

				let result_ = false;

				if(!self_.isEmpty(self_.active_[key_])) {
					const array_ = self_.active_[key_]
					const obj_ = array_[0]
					if(!self_.isEmpty(obj_)) {
						result_ = true;
					}
				}

				return result_
			},
			$_trvLyt_activeItemButtons() {
				const self_ = this;

				const array_ = self_.active_[self_.contentKey_]
				const id_ = array_[0].id
				
				return self_.contentVals_.itemButtons[id_]
			}
		}
	}
</script>

<style scoped>
	@media screen and (min-width:960px) {
		.row_ {
			height: 52px;
		}
		.sheet_ {
			min-height: calc(100vh - 246px);
		}
	}
</style>
